import React, { FC }                from "react";
import { useDispatch, useSelector } from "react-redux";
import { Input }                    from "semantic-ui-react";
import GetCustomersSearch           from "../../../application/usecase/customer/GetCustomersSearch";
import CustomerSearchValue          from "../../../domain/customer/criteria/CustomerSearchValue";
import CustomerSortType             from "../../../domain/customer/criteria/CustomerSortType";
import Customers                    from "../../../domain/customer/Customers";
import CurrentPage                  from "../../../domain/fundamentals/pagination/CurrentPage";
import { ResKaState }               from "../../../index";

const CustomersSearchBox: FC = () => {
  const customers: Customers = useSelector((state: ResKaState) => state.customers);
  const current: CurrentPage = customers.pagination.current;
  const search: CustomerSearchValue = customers.search;
  const sortType: CustomerSortType = customers.sortType;
  const getCustomerSearch: GetCustomersSearch = new GetCustomersSearch(useDispatch());
  return (
    <>
      <Input
        icon="search"
        placeholder="顧客検索"
        defaultValue={ search.value }
        onChange={ (event, data) => setTimeout(() => getCustomerSearch.execute(current, new CustomerSearchValue(data.value), sortType), 500) }
      />
    </>
  );
};

export default CustomersSearchBox;
